import { bundledArtPath, bundledArtEmoji } from "@greg-chick/shared";
import { contentBase } from "./contentApi";

/**
 * **안 올렸을 때 웹이 지금 실제로 보여주는 그림** — 관리자 미리보기용.
 *
 * ## 왜 필요한가
 * 웹은 그림을 네 군데서 가져온다: ①게시본(엣지) ②정적 매니페스트 ③**번들 파일**
 * ④절차적(코드로 그림). 관리자는 ①②만 병합해 보여줬다. 그래서 ③에 해당하는 것들이
 * "비어 있음"으로 보였다 — **화면에는 멀쩡히 나오고 있는데** 관리자에서는 없는 것처럼 보인다.
 * 운영자는 "안 올라갔나?" 하고 다시 올리게 된다.
 *
 * ③은 매니페스트에 없다. 파일이 저장소에 커밋돼 있고 코드가 경로를 직접 가리킨다.
 * 그 목록은 shared 에 있으므로(UI_ART 등) 여기서 URL 로 바꿔 준다.
 *
 * ⚠️ 여기 빠뜨리면 관리자만 "비어 있음"이라고 거짓말한다. 새로 번들 그림을 넣으면
 * 이 함수도 같이 고칠 것.
 */
export function bundledArtUrl(slotKey: string): string | undefined {
  // 목록은 shared 하나 — 웹이 실제로 쓰는 것과 같은 표다.
  // 관리자는 웹과 출처가 달라서(다른 포트·도메인) 절대 URL 로 바꿔 준다.
  const path = bundledArtPath(slotKey);
  return path ? `${contentBase()}${path}` : undefined;
}

/** 그림이 없을 때 화면에 나오는 이모지(있으면). 미리보기에 그대로 그린다. */
export function effectiveEmoji(slotKey: string): string | undefined {
  return bundledArtEmoji(slotKey);
}

/** 지금 화면에 **무언가 나오고 있는가** — 올린 것이든 번들이든 이모지든. */
export function isShownOnWeb(slotKey: string, hasEntry: boolean): boolean {
  return hasEntry || !!bundledArtPath(slotKey) || !!bundledArtEmoji(slotKey);
}
